import * as React from 'react'

import CardSlider from '../CardSlider/CardSlider'

const SliderLoader = ({
  sliderData,
  loadingComponent: LoadingComponent,
  dataLoaded,
  parentRef,
  hasError,
}) => {
  const loadingSlider = React.createRef(parentRef)

  if (!dataLoaded) {
    return (
      <CardSlider
        ref={loadingSlider}
        loadingComponent={LoadingComponent}
        dataSource={sliderData && sliderData.dataSource}
        initialSlide={0}
        renderItem={LoadingComponent}
      />
    )
  }

  if (sliderData.dataSource.length > 0 || hasError)
    return (
      <CardSlider
        ref={parentRef}
        loadingComponent={LoadingComponent}
        {...sliderData}
      />
    )

  return (
    <div style={{ display: 'flex' }}>
      {Array(3)
        .fill(null)
        .map((val, index) => (
          <LoadingComponent key={`loading-${index}`} />
        ))}
    </div>
  )
}

export default React.forwardRef((props, ref) => (
  <SliderLoader parentRef={ref} {...props} />
))
